<!-- 共享 xx 至资料库弹窗内容 -->
<template>
  <div :ref="itRef" class="shared-material">
    <p>{{ askTitle }}</p>
    <vh-checkbox v-model="isShared">{{ sharedTex }}</vh-checkbox>
  </div>
</template>
<script>
  import i18n from '@/common/i18n';
  export default {
    name: 'SharedMaterial',
    props: {
      itRef: String,
      name: String,
      title: String,
      // 默认勾选上
      checked: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      askTitle() {
        return this.title ? this.title : i18n.t('lang.k_056002', [this.name]);
      }
    },
    data() {
      return {
        isShared: this.checked,
        sharedTex: i18n.t('lang.k_056001')
      };
    }
  };
</script>
<style lang="less">
  .shared-material {
    p {
      line-height: 1.6;
    }
  }
</style>
